import { connect } from 'react-redux';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';
import { State } from 'widgets/free-content/root/root.reducers';

import EndOperation from 'modules/end-operation';
import { IEndOperationStoreProps } from 'modules/end-operation/end-operation.types';

const mapStateToProps = (state: State): IEndOperationStoreProps => {
    const platforms = state.event?.data?.platforms ?? [];
    const platformPC = platforms.find(
        (platform: { platform: string }) => platform.platform === PLATFORM_TYPES.PC
    );

    return {
        endDate: platformPC && platformPC.endDate
    };
};

const Container = connect(
    mapStateToProps
)(EndOperation);

export default Container;
